<template>
  <div class="home-content-box home-fqa-box">
    <div class="home-content-body body-max-container">
      <ul>
        <li>
          <div class="home-content-info">
            <div class="home-content-info-body">
              <div class="title">常見問題</div>
              <div class="subTitle">FQA</div>
              <div class="content">
                <img
                  class="moon-cat"
                  src="../../../assets/img/home/home-fqa-moon-cat.svg"
                  alt
                />
                <img
                  class="mountain"
                  src="../../../assets/img/home/home-fqa-mountain.png"
                  alt
                />
                <img
                  class="boy"
                  src="../../../assets/img/home/home-fqa-boy.svg"
                  alt
                />
                <img
                  class="girl"
                  src="../../../assets/img/home/home-fqa-girl.svg"
                  alt
                />
                <div v-show="activeFQA >= 0" class="faq-board-box">
                  <div v-if="activeFQA === 0" class="faq-board">
                    <div class="faq-q">
                      <span>平台是提供給誰使用呢？</span>
                    </div>
                    <div class="faq-a">
                      <span>無論你是教師、學生、家長、志工、一般大眾，歡迎透過「光之沃土-教育資源平台」閱覽與下載《十二夜》與《十二夜2：回到第零天》教育資源。</span>
                    </div>
                  </div>
                  <div v-if="activeFQA === 1" class="faq-board">
                    <div class="faq-q">
                      <span>平台的資料都可以免費使用嗎？</span>
                    </div>
                    <div class="faq-a">
                      <span>所有資料開放非營利授權、免費使用。引用時，請標註來源自「光之沃土-教育資源平台」，讓更多人知道這個平台，啟發更多責任。</span>
                    </div>
                  </div>
                  <div v-if="activeFQA === 2" class="faq-board">
                    <div class="faq-q">
                      <span>平台設計理念？</span>
                    </div>
                    <div class="faq-a">
                      <span>「光之沃土」希望幫助教師發展與動物保護議題有關的教學活動，讓飼主教育如「領養，不棄養」、「結紮，不放養」等觀念，成為孩子生命教育的一環，從根本改變對流浪動物的想法。</span>
                    </div>
                  </div>
                  <div v-if="activeFQA === 3" class="faq-board">
                    <div class="faq-q">
                      <span>什麼時候看得到教案成果呢？</span>
                    </div>
                    <div class="faq-a">
                      <span>預計自2023年，陸續蒐集教案資料。</span>
                    </div>
                  </div>
                  <div v-if="activeFQA === 4" class="faq-board">
                    <div class="faq-q">
                      <span>平台開放上傳教案嗎？</span>
                    </div>
                    <div class="faq-a">
                      <span>歡迎以動物保護為主題的創新教案，有意願者請寫信到「<span class="link-span" @click="goMail">光之沃土聯絡信箱</span>」。</span>
                    </div>
                  </div>
                  <div v-if="activeFQA === 5" class="faq-board">
                    <div class="faq-q">
                      <span>「光之沃土」有接受合作提案嗎？，怎麼聯絡你們？</span>
                    </div>
                    <div class="faq-a">
                      <span>無論是講座、座談、活動我們都有興趣參與，歡迎聯繫「<span class="link-span" @click="goMail">光之沃土聯絡信箱</span>」。</span>
                    </div>
                  </div>
                  <img class="left-hand" src="../../../assets/img/home/home-fqa-cat-hand.svg" alt />
                  <img class="right-hand" src="../../../assets/img/home/home-fqa-cat-hand.svg" alt />
                </div>
                <div class="fqa fqa-1" :class="{ active : activeFQA === 0 }" @click="activeFQA = 0">
                  <span>Q1</span>
                  <img :src="getFQABg" alt />
                </div>
                <div class="fqa fqa-2" :class="{ active : activeFQA === 1 }" @click="activeFQA = 1">
                  <span>Q2</span>
                  <img :src="getFQABg" alt />
                </div>
                <div class="fqa fqa-3" :class="{ active : activeFQA === 2 }" @click="activeFQA = 2">
                  <span>Q3</span>
                  <img :src="getFQABg" alt />
                </div>
                <div class="fqa fqa-4" :class="{ active : activeFQA === 3 }" @click="activeFQA = 3">
                  <span>Q4</span>
                  <img :src="getFQABg" alt />
                </div>
                <div class="fqa fqa-5" :class="{ active : activeFQA === 4 }" @click="activeFQA = 4">
                  <span>Q5</span>
                  <img :src="getFQABg" alt />
                </div>
                <div class="fqa fqa-6" :class="{ active : activeFQA === 5 }" @click="activeFQA = 5">
                  <span>Q6</span>
                  <img :src="getFQABg" alt />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FQABg from '../../../assets/img/home/home-fqa-bg.svg'
import FQABgMobile from '../../../assets/img/home/home-fqa-bg-mobile.svg'
import { DeviceTypeEnum, OSTypeEnum } from "@/utils/enum";
import IndexMixin from "@/mixins/index-mixin";
export default {
  name: "HomeFQA",
  mixins: [IndexMixin],
  data() {
    return {
      activeFQA: -1
    };
  },
  computed: {
    getFQAData() {
      if (this.activeFQA >= 0) {
        return window.config["FQA"][this.activeFQA]
      } else {
        return {
          Q: "",
          A: ""
        }
      }
    },
    getFQABg() {
      return (this.$store.getters.device === DeviceTypeEnum.MOBILE) ? FQABgMobile : FQABg
    }
  },
  methods: {
    goAbout() {
      this.$router.push({ name: "About" });
    },
    goMail() {
      if (this.$store.getters.os === OSTypeEnum.WEB) {
        window.open("mailto:12nights2018@gmail.com", '_blank')
      } else {
        if (navigator.clipboard) {
          navigator.clipboard.writeText("12nights2018@gmail.com").then(() => {
            this.$12nightsAlert({
              title: "提示",
              message: "已複製網址到剪貼簿，或可以複製以下Mail，到您常用的Mail寄送到『12nights2018@gmail.com』"
            }).then(() => {
            })
          }).catch(() => {
            this.$12nightsAlert({
              title: "提示",
              message: "可以複製以下Mail，到您常用的Mail寄送到『12nights2018@gmail.com』"
            }).then(() => {
            })
          })
        } else {
          this.$12nightsAlert({
            title: "提示",
            message: "可以複製以下Mail，到您常用的Mail寄送到『12nights2018@gmail.com』"
          }).then(() => {
          })
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.link-span {
  display: unset !important;
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
</style>
